import React, { useState, useEffect } from 'react';
import { Alert, IconButton, Collapse, Box } from '@mui/material';
import { Close, Warning as WarningIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useAlert } from './AlertProvider';

const WarningContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  width: '100%'
}));

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: 0,
  fontSize: '20px',
  fontWeight: 700,
  padding: theme.spacing(2.5, 3),
  minHeight: '80px',
  display: 'flex',
  alignItems: 'center',
  '& .MuiAlert-message': {
    width: '100%',
    paddingRight: theme.spacing(1),
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left'
  },
  '& .MuiAlert-icon': {
    fontSize: '24px',
    marginRight: theme.spacing(1.5),
    alignSelf: 'center'
  },
  '& .MuiAlert-action': {
    alignItems: 'center',
    paddingTop: 0
  }
}));

const GlobalWarning = ({
  message,
  severity = 'warning',
  dismissible = true,
  storageKey = 'globalWarningDismissed'
}) => {
  const { isAlertDismissed, setAlertDismissed } = useAlert();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isAlertDismissed(storageKey) && message) {
      setIsVisible(true);
    }
  }, [message, storageKey, isAlertDismissed]);

  const handleClose = () => {
    setIsVisible(false);
    if (dismissible && storageKey) {
      setAlertDismissed(storageKey);
    }
  };

  if (!message) {
    return null;
  }

  return (
    <WarningContainer>
      <Collapse in={isVisible}>
        <StyledAlert
          severity={severity}
          icon={<WarningIcon />}
          action={
            dismissible ? (
              <IconButton
                aria-label="close warning"
                color="inherit"
                size="medium"
                onClick={handleClose}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                <Close fontSize="medium" />
              </IconButton>
            ) : null
          }
        >
          {message}
        </StyledAlert>
      </Collapse>
    </WarningContainer>
  );
};

export default GlobalWarning;
